import Routers from "./routers/Routers";
import "antd/dist/reset.css";
import { App as AntdApp } from "antd"; 

const App = () => {
  return (
    <AntdApp>
      <Routers />
    </AntdApp>
  );
};

export default App;
